import axios from 'axios'
import type { AxiosInstance } from 'axios'
import alert from './alert'
import loader from './loader'
import appConfig from '@/config'
import storageService from './storage'

const HTTP: AxiosInstance = axios.create({
  baseURL: appConfig.apiBaseUrl,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json'
  }
})

//before request actions
HTTP.interceptors.request.use(async (config) => {
  config.headers['X-Access-Token'] = storageService.getUserAccessToken()
  config.headers['X-Device'] = 'web'

  loader.show()

  return config
})

//after response actions
HTTP.interceptors.response.use(
  (response) => {
    loader.hide()
    return response
  },
  (error) => {
    if (error.response?.data?.errCode === 'session-not-found') {
      storageService.signOut()
    }

    if (error.code === 'ERR_NETWORK') {
      alert.warn('Please check your internet connection then refresh page')
    } else if (error.response?.data) {
      alert.error(getErrorMessage(error.response?.data))
    } else {
      alert.error('Please contact technical support')
    }
    loader.hide()
    return Promise.reject(error)
  }
)

const getErrorMessage = (data: {
  error?: {
    field: string
    message: string
  }
  message?: string
}) =>
  data.error
    ? `${data.error.field}: ${data.error.message}`
    : data.message
      ? data.message
      : 'Please contact technical support'

export default HTTP
